import { createFileRoute } from '@tanstack/react-router';

import { MyCalendarScreen } from '@/features/calendar/components/MyCalendarScreen';
import { MyPractitionerLayout } from '@/features/practitioners/components/shared/MyPractitionerLayout';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/calendar/')({
  beforeLoad: () => {
    requirePermission('session:read');
  },
  component: ClinicalMyCalendarRoute,
  staticData: { crumb: 'My calendar' },
});

function ClinicalMyCalendarRoute() {
  return (
    <MyPractitionerLayout>
      {(practitionerId) => <MyCalendarScreen practitionerId={practitionerId} />}
    </MyPractitionerLayout>
  );
}
